<template>
  <div class="detail_main bg_detail is-scrollable has-background-white">
    <div class="detail_img_info">
      <a
        class="button has-text-white is-rounded diapo_button"
        @click="$parent.show = false">
        <span class="icon">
          <b-icon
            icon="chevron-left">
          </b-icon>
        </span>
        <label>Retour</label>
      </a>
      <img :src="url" class="imageBgOpp imgGoToTop">
    </div>
    <div class="leftVert topViolet rightVert bottomVert">
      <div class="tabs bottomVert">
        <ul class="p_size12 has-text-weight-bold">
          <li :class="{'underline is-active': active === 1}"
              @click="active = 1"
              class="is-paddingless">
            <a>Caractéristiques</a>
          </li>
          <li :class="{'underline is-active': active === 2}"
              @click="active = 2"
              class="is-paddingless">
            <a>Visibilité</a>
          </li>
        </ul>
      </div>
      <div v-if="active === 1">
        <div class="columns is-mobile is-marginless is-multiline color-icon">
          <div class="column is-6 is-paddingless bottomViolet" v-if="detailFace.facCode">
            <div class="media">
              <b-icon
                icon="barcode"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-dark is-size-7">
                  <label class="has-text-default">
                    Code face
                  </label><br>
                  <p class="p_size12 has-text-weight-bold">
                    {{detailFace.facCode ? detailFace.facCode : detailFace.code}}
                  </p>
              </div>
            </div>
          </div>
          <div class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="panorama-wide-angle"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-dark is-size-7">
                  <label class="has-text-default">
                    Panneau
                  </label><br>
                  <p class="p_size12 has-text-weight-bold">
                    {{detailFace.panCode ? detailFace.panCode : detailFace.panCote}}
                  </p>
              </div>
            </div>
          </div>
          <div class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="vector-intersection"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-dark is-size-7">
                  <label class="has-text-default">
                    Format
                  </label><br>
                  <p class="p_size12 has-text-weight-bold">
                    {{detailFace.format}}
                  </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFace.materiel"
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="package-variant-closed"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-dark is-size-7">
                  <label class="has-text-default">
                    Matériel
                  </label><br>
                  <p class="p_size12 has-text-weight-bold">
                    {{detailFace.materiel}}
                  </p>
              </div>
            </div>
          </div>
          <div
            v-if="detailFace.support"
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="sign-text"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-dark is-size-7">
                  <label class="has-text-default">
                    Support
                  </label><br>
                  <p class="p_size12 has-text-weight-bold">
                    {{detailFace.support}}
                  </p>
              </div>
            </div>
          </div>
          <div
            class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="lightbulb-on-outline"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-dark is-size-7">
                  <label class="has-text-default">
                    Éclairé
                  </label><br>
                  <p class="p_size12 has-text-weight-bold">
                    {{eclaire}}
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="active === 2">
        <div class="columns is-mobile is-marginless is-multiline color-icon">
          <div class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="map-marker-circle"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-dark is-size-7">
                  <label class="has-text-default">
                    Localisation
                  </label><br>
                  <p class="p_size12 has-text-weight-bold">
                    {{detailFace.localisation ?
                      detailFace.localisation :
                      'Non renseignée'}}
                  </p>
              </div>
            </div>
          </div>
          <div class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="angle-obtuse"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-dark is-size-7">
                  <label class="has-text-default">
                    Angle de vision
                  </label><br>
                  <p class="p_size12 has-text-weight-bold">
                    {{detailFace.angleDeVision ?
                      detailFace.angleDeVision :
                      'Non renseignée'}}
                  </p>
              </div>
            </div>
          </div>
          <div class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="arrow-right"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-dark is-size-7">
                  <label class="has-text-default">
                    En venant de
                  </label><br>
                  <p class="p_size12 has-text-weight-bold">
                    {{detailFace.enVenantDe ?
                      detailFace.enVenantDe :
                      'Non renseignée'}}
                  </p>
              </div>
            </div>
          </div>
          <div class="column is-6 is-paddingless bottomViolet">
            <div class="media">
              <b-icon
                icon="arrow-left"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-dark is-size-7">
                  <label class="has-text-default">
                    En allant vers
                  </label><br>
                  <p class="p_size12 has-text-weight-bold">
                    {{detailFace.enAllantVers ?
                      detailFace.enAllantVers :
                      'Non renseignée'}}
                  </p>
              </div>
            </div>
          </div>
          <div
            v-if="adresse"
            class="column is-paddingless">
            <div class="media">
              <b-icon
                icon="map-marker"
                size="is-medium"
                class="media-left">
              </b-icon>
              <div class="media-content has-text-dark is-size-7">
                  <label class="has-text-default">
                    Adresse
                  </label><br>
                  <p class="p_size12 has-text-weight-bold">
                    {{adresse}}
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { urlPhoto, formatEclaire, formatAdresse } from '@/services/opportunite/formatTab';

export default {
  name: 'detailReseauxPersonnaliseComplet',
  props: ['detailFace'],
  data() {
    return {
      active: 1,
      select: true,
    };
  },
  computed: {
    url() {
      return urlPhoto(this.detailFace.urlPhoto);
    },
    eclaire() {
      return formatEclaire(this.detailFace.eclaire);
    },
    adresse() {
      return formatAdresse(this.detailFace);
    },
  },
  mounted() {
    const test = document.querySelector('html');
    test.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    test.style.overflow = '';
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxPersonnalise/detailReseauxPersonnaliseComplet.vue